import { HStack, VStack, Text, Tooltip } from "@reverb-ui/react";
import { TopExperienceContext } from "presentation/containers/context-api/TopExperienceProvider";
import { useContext } from "react";
import InformationMessage from "./InformationMessage";

export const TopExperienceData: React.FC = () => {
  const { topExperienceData } = useContext(TopExperienceContext);
  return (
    <>
      <VStack
        paddingTop="1.875rem"
        display="flex"
        justifyContent="flex-start"
        height="full"
      >
        {topExperienceData?.topExperiences?.map(
          (
            value: {
              position: string;
              description: string;
              percentage: string;
            },
            index: any
          ) => (
            <HStack
              width="full"
              display="flex"
              justifyContent="space-between"
              key={index}
              paddingBottom="1.400rem"
            >
              <HStack>
                <Text color="blue.500" fontSize="20px" whiteSpace={"nowrap"}>
                  {`${value.position}º`}
                </Text>
                <Tooltip
                  label={value.description}
                  placement="bottom"
                  bg="gray.100"
                  color="gray.800"
                >
                  <Text color="gray.700" fontSize="18px" fontWeight={700}>
                    {value.description.replace(/(.{15})..+/, "$1…")}
                  </Text>
                </Tooltip>
              </HStack>
              <Text color="gray.700" fontSize="20px" whiteSpace={"nowrap"}>
                {value.percentage}
              </Text>
            </HStack>
          )
        )}
      </VStack>
      {topExperienceData && topExperienceData.topExperiences?.length < 5 && (
        <VStack
          paddingBottom="1.300rem"
          display="flex"
          justifyContent="flex-end"
          height="full"
        >
          <InformationMessage messageText="There aren't 5 sources to show yet." />
        </VStack>
      )}
    </>
  );
};
